import {
    ADDORUPDATEENTITYTYPELIST_SUCCESS,
    ADDORUPDATEENTITYTYPELIST_FAILED,
    RESET_ADDORUPDATEENTITYTYPELIST,
    LOADING_ADDORUPDATEENTITYTYPELIST,
    NETWORK_ERROR_ADDORUPDATEENTITYTYPELIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAddOrUpdateEntityTypeList = () => {
    return { type: RESET_ADDORUPDATEENTITYTYPELIST };
};

const addOrUpdateEntityTypeList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDORUPDATEENTITYTYPELIST });
    await adminServices
        .post("addOrUpdateEntityType", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(addOrUpdateEntityTypeListsuccess(res.data));
                    break;
                default:
                    dispatch(addOrUpdateEntityTypeListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_ADDORUPDATEENTITYTYPELIST, payload: err });
        });
};
function addOrUpdateEntityTypeListsuccess(data) {
    return {
        type: ADDORUPDATEENTITYTYPELIST_SUCCESS,
        payload: data,
    };
}
function addOrUpdateEntityTypeListFailed(data) {
    return {
        type: ADDORUPDATEENTITYTYPELIST_FAILED,
        payload: data,
    };
}

export { resetAddOrUpdateEntityTypeList, addOrUpdateEntityTypeList };
